import React, { FC } from "react";
import { Box, BoxProps } from "theme-ui";

type BoxGreyType = {
  hasBg?: any;
} & BoxProps;
export const BoxGrey: FC<BoxGreyType> = ({
  hasBg,
  children,
  ...props
}: BoxGreyType) => {
  if (hasBg) {
    return (
      <Box variant="boxes.backgrounds.grey" {...props}>
        {children}
      </Box>
    );
  }

  return <Box {...props}>{children}</Box>;
};

BoxGrey.defaultProps = {
  hasBg: true,
};
